<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#fff" type="ball-clip-rotate-multiple"
[fullScreen]="true">
<p style="color: white">{{setLabel("pleaseWaitLabel")}}</p>
</ngx-spinner>

<p-dialog [(visible)]="emailConfirmationModal" [closeOnEscape]="true" [focusOnShow]="false" (onHide)="dialogClose()">
   <p-header>
      {{setLabel("sendReportLabel")}}
   </p-header>
   <form #emailConfirmationForm="ngForm">
      <div style="height: 60vh;">
         <div class="p-g-12" style="padding-bottom: 20px;">
            <div class="p-inputgroup">
               <span class="p-inputgroup-addon" [pTooltip]='setLabel("sendToTooltipLabel")' tooltipPosition="top"><i class="fa fa-user"
                     aria-hidden="true"></i></span>
               <input autocomplete="off" [(ngModel)]="email.to" type="text"  pInputText [placeholder]='setLabel("toPlaceholderLabel")' name="to"
                  required style="width: 100% !important;" pattern="^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+,*[\W]*)+$" >
            </div>
         </div>
         <div class="p-g-12" style="padding-bottom: 20px;">
            <div class="p-inputgroup">
               <span class="p-inputgroup-addon" [pTooltip]='setLabel("subjectTooltipLabel")' tooltipPosition="top"><i class="fa fa-envelope"
                     aria-hidden="true"></i></span>
               <input autocomplete="off" [(ngModel)]="email.subject" type="text" pInputText [placeholder]='setLabel("subjectPlaceholderLabel")'
                  name="subject" required style="width: 100% !important;">
            </div>
         </div>
         <div class="p-g-12">
            <div class="p-inputgroup">
               <span class="p-inputgroup-addon" [pTooltip]='setLabel("bodyTooltipLabel")' tooltipPosition="top"><i class="fa fa-pencil-square-o"
                     aria-hidden="true"></i></span>
                     <ckeditor name="ckeditor" style="width: 100%; -webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box;" [editor]="Editor" [(ngModel)]="email.body"></ckeditor>
               <!-- <p-editor [(ngModel)]="email.body" style="width: 100%;" name="body" [style]="{'height':'320px'}">
               </p-editor> -->
            </div>
         </div>
         <!-- <div class="p-g-12">
               <div class="p-inputgroup">
                   <span class="p-inputgroup-addon"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></span>
                   <textarea class="textarea" rows="5" cols="80" style="width: 100%; -webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box;"
                   [(ngModel)]="email.body" placeholder="Body" name="body" pInputTextarea></textarea>
               </div>
           </div> -->
      </div>
   </form>
   <p-footer style="align-items: end;display: inline-flex;margin-right: 4rem;">
      <div style="display: flex;justify-content: space-evenly;margin-right: 0rem;width: fit-content;">
         <button style="background: #e7e7e7; color:black;margin-top: 10px;" (click)="dialogClose()" pButton
            class="p-button p-widget p-state-default p-corner-all p-button-text-only">{{setLabel("cancelLabel")}}</button>
         <button style="background: #4CAF50; color:white;margin-top: 10px;" (click)="sendEmailAsPdf()" pButton
            [disabled]="!emailConfirmationForm.valid"
            class="p-button p-widget p-state-default p-corner-all p-button-text-only">{{setLabel("sendLabel")}}</button>
      </div>
   </p-footer>
</p-dialog>
